import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FilterItem from './filter-item/filter-item';
import './filters-bar.css';

class FiltersBar extends Component {
  constructor(props) {
    super(props);

    this._setInitialState();
  }

  _setInitialState() {
    const items = this.setupItems();
    
    if (this.props.isAllOn) {
      items.unshift({
        id: 'all',
        text: 'All',
        isSelected: true,
        onClick: this.onFilterClick
      });
    }
    else {
      items[0].isSelected = true;
    }

    this.state = { items };

    // const firstItemId = items[0].id;
    // if (firstItemId === 'all') {
    //   this.props.onClearAllClick();
    //   return;
    // }

    // this.props.onFilterClick(firstItemId);
  }

  onFilterClick = (selectedFilter) => {
    this.updateStateBySelectedFilterId(selectedFilter.id);

    if (selectedFilter.id === 'all') {
      this.props.onClearAllClick();
      return;
    }

    this.props.onFilterClick(selectedFilter);
  }

  updateStateBySelectedFilterId(selectedId) {
    this.setState((prevState) => {
      const updatedItems = prevState.items.map((item) => {
        return Object.assign({}, item, {
          isSelected: item.id === selectedId
        });        
      });

      return {
        items: updatedItems
      };
    });
  }

  setupItems() {
    return this.props.items.map((item) => {
      return Object.assign({
        onClick: this.onFilterClick,
        isSelected: false
      }, item);
    });
  }

  render() {
    const listItems = this.state.items.map((item) => 
      <li key={item.id}>
        <FilterItem {...item}/>
      </li>
    );

    return (
      <ul className='filters-bar'>
        {listItems}
      </ul>
    );
  }
}

FiltersBar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  })).isRequired,

  onFilterClick: PropTypes.func.isRequired,
  isAllOn: PropTypes.bool,
  onClearAllClick: PropTypes.func
};

FiltersBar.defaultProps = {
  isAllOn: true
};

export default FiltersBar;